/**
* Jsll.ts
* @author Ram Thiru (ramthi) and Hector Hernandez (hectorh)
* @copyright Microsoft 2020
* JSLL Clickstream Tracker.
*/
import { DataCollector } from "@microsoft/1ds-wa-js";
import { objForEachKey } from "@microsoft/applicationinsights-core-js";
import { notImplementedWarn } from "./Utils";
var ClickstreamTracker = /** @class */ (function () {
    function ClickstreamTracker(sku) {
        // NO OP
        this.testHook = {};
        this._sku = sku;
    }
    ClickstreamTracker.prototype.capturePageView = function (overrideValues) {
        // All other overrides will be ignored
        var overrides = null;
        if (overrideValues) {
            overrides = {
                referrerUri: overrideValues.referrerUri,
                behavior: overrideValues.behavior,
                pageName: overrideValues.pageName,
                pageTags: overrideValues.pageTags,
                isAuto: overrideValues.isAuto
            };
        }
        this._sku.getWebAnalyticsExtension().capturePageView(overrides);
    };
    ClickstreamTracker.prototype.captureContentUpdate = function (overrideValues) {
        // All other overrides will be ignored
        var overrides = null;
        if (overrideValues) {
            overrides = {
                content: overrideValues.content,
                isDomComplete: overrideValues.isDomComplete,
                actionType: overrideValues.actionType,
                behavior: overrideValues.behavior,
                pageName: overrideValues.pageName,
                pageTags: overrideValues.pageTags,
                isAuto: overrideValues.isAuto
            };
        }
        this._sku.getWebAnalyticsExtension().captureContentUpdate(overrides);
    };
    ClickstreamTracker.prototype.capturePageAction = function (element, overrideValues) {
        // All other overrides will be ignored
        var overrides = null;
        if (overrideValues) {
            overrides = {
                refUri: overrideValues.referrerUri,
                actionType: overrideValues.actionType,
                targetUri: overrideValues.targetUri,
                content: overrideValues.content,
                contentTags: overrideValues.contentTags,
                behavior: overrideValues.behavior,
                pageName: overrideValues.pageName,
                pageTags: overrideValues.pageTags,
                isAuto: overrideValues.isAuto
            };
        }
        this._sku.getWebAnalyticsExtension().capturePageAction(element, overrides);
    };
    ClickstreamTracker.prototype.captureContentPageAction = function (overrideValues) {
        this.capturePageAction(null, overrideValues);
    };
    ClickstreamTracker.prototype.captureClientError = function (error) {
        var exceptionTelemetry = {};
        // displayedToUser concept doesn't exist in 1DS
        // Other overrides available in JSLL were for properties that doesn't exist in Exception schema, so we will ignore those
        exceptionTelemetry.exception = error.errorInfo;
        this._sku.getWebAnalyticsExtension().trackException(exceptionTelemetry);
    };
    ClickstreamTracker.prototype.captureQos = function (qosEvent) {
        if (qosEvent && qosEvent.data && qosEvent.data.baseData) {
            var dependencyTelemetry = {
                id: "",
                duration: qosEvent.data.baseData.latencyMs,
                success: qosEvent.data.baseData.succeeded,
                responseCode: Number(qosEvent.data.baseData.protocolStatusCode),
                type: qosEvent.data.baseData.dependencyType,
                target: qosEvent.data.baseData.targetUri
            };
            // Add everything else to part C
            var customProperties_1 = {};
            objForEachKey(qosEvent.data.baseData, function (key, value) {
                if (key !== "latencyMs" && key !== "succeeded" && key !== "protocolStatusCode" && key !== "dependencyType" && key !== "targetUri") {
                    customProperties_1[key] = value;
                }
            });
            objForEachKey(qosEvent.data, function (key, value) {
                if (key !== "baseData" && key !== "baseType") {
                    customProperties_1[key] = value;
                }
            });
            this._sku.getQosExtension().trackDependencyData(dependencyTelemetry, customProperties_1);
        }
    };
    ClickstreamTracker.prototype.getUri = function (windowLocation) {
        return DataCollector._getUri(this._sku.getWebAnalyticsExtensionConfig(), windowLocation);
    };
    ClickstreamTracker.prototype.getPageContent = function (viewportBoundingRect) {
        // NO OP
        notImplementedWarn("getPageContent");
        return "";
    };
    ClickstreamTracker.prototype.getTimeToClick = function () {
        // NO OP
        notImplementedWarn("getTimeToClick");
        return -1;
    };
    ClickstreamTracker.prototype.initialize = function (config) {
        // NO OP
        notImplementedWarn("ClickstreamTracker initialize");
    };
    ClickstreamTracker.prototype.captureCorsDisallowed = function (overrideValues) {
        // NO OP
        notImplementedWarn("captureCorsDisallowed");
    };
    ClickstreamTracker.prototype.captureEventTooLong = function (overrideValues) {
        // NO OP
        notImplementedWarn("captureEventTooLong");
    };
    ClickstreamTracker.prototype.captureEventDrop = function (errorInfo) {
        // NO OP
        notImplementedWarn("captureEventDrop");
    };
    ClickstreamTracker.prototype.captureSwap = function (overrideValues) {
        // NO OP
        notImplementedWarn("captureSwap");
    };
    ClickstreamTracker.prototype.domReadyTasksWrapper = function () {
        // NO OP
        notImplementedWarn("domReadyTasksWrapper");
    };
    ClickstreamTracker.prototype.domReadyTasks = function () {
        // NO OP
        notImplementedWarn("domReadyTasks");
    };
    ClickstreamTracker.prototype.onDomReadyDo = function (f) {
        // NO OP
        notImplementedWarn("onDomReadyDo");
    };
    return ClickstreamTracker;
}());
export { ClickstreamTracker };
//# sourceMappingURL=ClickstreamTracker.js.map